import { useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from 'src/common/utils/api';

type GenerateMeetingNotePayload = {
  dataUploadFileId: string;
  templateId?: string;
  agendaFileId?: string;
  meetingDate?: Date;
  summarise?: boolean;
};

export function useGenerateMeetingNote() {
  const queryClient = useQueryClient();

  const {
    mutateAsync,
    error,
    isPending: isLoading,
    reset,
  } = useMutation<unknown, Error, { clientId: string; values: GenerateMeetingNotePayload }>({
    mutationFn: ({ clientId, values }: { clientId: string; values: GenerateMeetingNotePayload }) =>
      api.post(`clients/${clientId}/meeting-notes`, values),
    onSuccess: (_data, { clientId }) => {
      queryClient.invalidateQueries({ queryKey: ['clients', clientId, 'meeting-notes'] });
    },
  });

  const generateMeetingNote = async (clientId: string, values: GenerateMeetingNotePayload) => {
    return mutateAsync({ clientId, values });
  };

  return {
    generateMeetingNote,
    error,
    isLoading,
    reset,
  };
}
